var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.a00ae3889e9a3632b3c6e219e715d304.svg#facebook--p3tbs';
                    var viewUrl = 'sprites.a00ae3889e9a3632b3c6e219e715d304.svg#view-facebook--p3tbs';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 11 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };